import React from 'react';
import { ReactComponent as WarningIcon } from 'images/success.svg';
import { AllResolvedWrapper } from './styles/AllResolvedStyles';

const AllResolved = () => {
  return (
    <AllResolvedWrapper>
      <WarningIcon />
      <div>All discrepancies have been resolved.</div>
    </AllResolvedWrapper>
  );
};

export default AllResolved;
